import React from 'react';
import { Badge } from 'reactstrap';

const EstatusPagoBadge = ({ estatusPago }) => {
  if (!estatusPago) {
    return (
      <span className="badge bg-warning-subtle text-warning">
        <i className="ri-time-line me-1"></i>
        Pendiente
      </span>
    );
  }

  const getStatusConfig = (status) => {
    const configs = {
      'Pagada': {
        color: 'success',
        icon: 'ri-checkbox-circle-line',
        text: 'Pagada'
      },
      'Pendiente': {
        color: 'warning',
        icon: 'ri-time-line',
        text: 'Pendiente'
      },
      'Rechazada': {
        color: 'danger',
        icon: 'ri-close-circle-line',
        text: 'Rechazada'
      },
      'En Revisión': {
        color: 'info',
        icon: 'ri-search-line',
        text: 'En Revisión'
      }
    };

    return configs[status] || {
      color: 'secondary',
      icon: 'ri-question-line',
      text: status
    };
  };

  const config = getStatusConfig(estatusPago);

  return (
    <span className={`badge bg-${config.color}-subtle text-${config.color}`}>
      <i className={`${config.icon} me-1`}></i>
      {config.text}
    </span>
  );
};

export default EstatusPagoBadge;
